export default __webpack_public_path__ + "static/media/finalstep.4ee4df88.svg";